import BookingSummary from "./BookingSummary";
import { useApartmentSummaryBaseProps } from "../common/components/BookingOverview/useApartmentSummaryBaseProps";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";
import { useEnsureApartmentDetails } from "../common/hooks/useEnsureApartmentDetails";

// roomRental has no dedicated confirmation step (payment is the last step),
// so the soft-signup prompt sits under the booking summary — the analogous
// bottom slot to the other flows' confirmation ticket.
const BookingOverview = () => {
  // Same refresh self-heal as the venue summary: restore the room details
  // (and the group id the reservation call needs) when hydration lands
  // directly on this step.
  useEnsureApartmentDetails();
  return (
    <>
      <BookingSummary {...useApartmentSummaryBaseProps()} />
      <SoftSignupPrompt />
    </>
  );
};

export default BookingOverview;
